import React      from 'react';
import styled     from 'styled-components';
import { Button } from '@components/index';
import {
  Dialog as MuiDialog,
  DialogContent,
  DialogContentText as MuiDialogContentText,
  DialogActions as MuiDialogActions,
}                 from '@material-ui/core';

interface IProps {
  width           : string;
  onCancel        : () => void;
  onConfirm       : () => void;
  isOpen          : boolean;
  isAccountSaving : boolean;
}

const Dialog = styled(MuiDialog)`
  && {
    [class^="MuiPaper-"] {
      border-radius : 5px;
      padding       : 20px;
    }
  }
` as any;

const DialogContentText = styled(MuiDialogContentText)`
  && {
    text-align : center;
    font-size  : 18px;
    color      : ${({ theme: { textColor } }): string => textColor.secondary};
  }
` as any;

const DialogActions = styled(MuiDialogActions)`
  && {
    justify-content: center;
    ${({ theme: { width } }: any): false | string => (width === 'xs' && 'flex-direction: column')};

    > * + * {
      margin-left: 20px;
    }
  }
` as any;

export const BlankFieldsWarningModal = ({
  width,
  isOpen,
  isAccountSaving,
  onCancel,
  onConfirm,
}: IProps): JSX.Element => (
  <Dialog
    aria-labelledby = "unfilled-fields-info-dialog"
    open            = {isOpen}
    maxWidth        = "xs"
  >
    <DialogContent>
      <DialogContentText>
        Institution’s Name, City and/or State have not been filled in.
        Do you wish to continue and save this account?
      </DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button
        variant   = "outlined"
        width     = "180"
        fullWidth = {width === 'xs'}
        onClick   = {onCancel}
      >
        Cancel
      </Button>

      <Button
        width     = "180"
        fullWidth = {width === 'xs'}
        isLoading = {isAccountSaving}
        onClick   = {onConfirm}
      >
        Yes, Save
      </Button>
    </DialogActions>
  </Dialog>
);
